module.exports = __webpack_public_path__ + "static/media/facebook.480ed493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/checkout-success-step/facebook.png
// module id = 659
// module chunks = 0